<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <div v-else>
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
          <strong>PRI Calculation Overview</strong>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto"></b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-row class="mt-1">
        <b-col cols="3">
          <DetailsComponent :searchData="searchData" />
        </b-col>
        <b-col cols="9">
          <b-tabs>
            <b-tab title="Calculation">
              <CalculationComponent :isLoading="isLoading" />
            </b-tab>
            <b-tab title="Media results data (historic)">
              <MediaResultsDataComponent
                :bingSearchArray="bingSearchArray"
                :googleSearchArray="googleSearchArray"
                :priSearchKeyWords="priSearchKeyWords"
              />
            </b-tab>

            <b-tab
              :title="'Sanctions & Enforcements Alerts('+sanctions.length+')'"
              v-if="priSearchData.sanctions.isIDD"
            >
              <SanctionsEnforcementsAlertsComponent :sanctions="sanctions" />
            </b-tab>
            <b-tab title="Open Corporate Data" class="p-3">
              <OpenCorporateDataComponent
                :openCorporateGlobalExactMatchTotals="openCorporateGlobalExactMatchTotals"
                :openCorporateCountryExactMatchTotals="openCorporateCountryExactMatchTotals"
                :openCorporateGlobalPartialMatchTotals="openCorporateGlobalPartialMatchTotals"
                :openCorporateCountryPartialMatchTotals="openCorporateCountryPartialMatchTotals"
                :openCorporateCompanyData="openCorporateCompanyData"
                :companyTotals="companyTotals"
              />
            </b-tab>
            <b-tab title="Future Risks">
              <FutureRisksComponent :futureRisksArray="futureRisksArray" />
            </b-tab>
            <b-tab title="Configuration" v-if="priSearchData">
              <ConfigurationComponent :form="priSearchData" />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AppLoader from "../components/Loader/Loader";
import ConfigurationComponent from "../components/Pri/priSearchComponent/configurationComponent.vue";
import DetailsComponent from "../components/Pri/priSearchComponent/detailsComponent.vue";
import CalculationComponent from "../components/Pri/priSearchComponent/calculationComponent.vue";
import MediaResultsDataComponent from "../components/Pri/priSearchComponent/mediaResultsDataComponent.vue";
import SanctionsEnforcementsAlertsComponent from "../components/Pri/priSearchComponent/sanctionsEnforcementsAlertsComponent.vue";
import OpenCorporateDataComponent from "../components/Pri/priSearchComponent/openCorporateDataComponent.vue";
import FutureRisksComponent from "../components/Pri/priSearchComponent/futureRisksComponent.vue";
import { HTTP } from "../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "PriSearchContainer",
  components: {
    AppLoader,
    DetailsComponent,
    CalculationComponent,
    MediaResultsDataComponent,
    SanctionsEnforcementsAlertsComponent,
    OpenCorporateDataComponent,
    FutureRisksComponent,
    ConfigurationComponent
  },
  data() {
    return {
      searchData: null,
      isLoading: true,
      bingSearchArray: [],
      googleSearchArray: [],
      googleItemsArray: [],
      futureRisksArray: [],
      priSearchData: undefined,
      priSearchKeyWords: [],
      sanctions: [],
      companyTotals: null,
      openCorporateCompanyData: null,
      openCorporateGlobalExactMatchTotals: null,
      openCorporateCountryExactMatchTotals: null,
      openCorporateGlobalPartialMatchTotals: null,
      openCorporateCountryPartialMatchTotals: null
    };
  },
  computed: {},
  mounted() {
    this.isLoading = true;
    this.getSearchData(this.$route.params.searchId);
  },
  methods: {
    // checkValue() {
    //   let metaData = JSON.parse(this.searchData.meta_data);
    //   metaData.map(value => {
    //     value.customAtValue.map(element => {
    //     });
    //   });
    // },
    age(value) {
      moment.locale("en");

      return moment.utc(value).fromNow();
    },
    async getSearchData(searchId) {
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let response = await HTTP(
        "get",
        "v1/onboading/search/" + searchId,
        null,
        {
          Authorization: token
        }
      );

      this.searchData = response.data;
      let priData = JSON.parse(response.data.pri_configuration);
      this.priSearchKeyWords = priData.negativeMedia.searchKeywords;

      this.priSearchData = priData;
      if (response.data && response.data.search_results) {
        let JSonData = JSON.parse(response.data.search_results);

        this.bingSearchArray = JSonData.bing;
        this.googleSearchArray = JSonData.google;
        this.futureRisksArray = JSonData.futureRisks;
        this.sanctions = JSonData.sanctions;
        this.companyTotals = JSonData.openCorporateTotals;
        this.openCorporateCompanyData = JSonData.openCorporateCompanyData;
        this.openCorporateGlobalExactMatchTotals =
          JSonData.openCorporateGlobalExactMatchTotals;
        this.openCorporateCountryExactMatchTotals =
          JSonData.openCorporateCountryExactMatchTotals;
        this.openCorporateGlobalPartialMatchTotals =
          JSonData.openCorporateGlobalPartialMatchTotals;
        this.openCorporateCountryPartialMatchTotals =
          JSonData.openCorporateCountryPartialMatchTotals;
      }

      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
span.sort-icon {
  float: right;
  color: #ff9100;
}
</style>
